const extractRegionFromLocale = (locale: string): string | null => {
  try {
    const region = new Intl.Locale(locale).region;
    return region ? region.toLowerCase() : null;
  } catch {
    const part = locale.split("-")[1];
    return part?.length === 2 ? part.toLowerCase() : null;
  }
};

/**
 * Derives a default phone country code from the browser locale region
 * (e.g. en-GB → gb, en-SG → sg). Falls back when no region is present.
 */
export const resolveDefaultPhoneCountry = (fallback = "gb"): string => {
  if (typeof navigator === "undefined") {
    return fallback;
  }

  const candidates =
    navigator.languages?.length > 0
      ? navigator.languages
      : [navigator.language];

  for (const locale of candidates) {
    const region = extractRegionFromLocale(locale);
    if (region) {
      return region;
    }
  }

  return fallback;
};
